import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  titleDialog: {
    textAlign: 'center'
  }
}));

export default useStyles;
